import { UnlockItemsPopupLayout } from 'Layouts/Farm/UnlockItemsPopupLayout';
import BaseMenu from '../BaseMenu';
import BaseUISystem from '../../BaseUISystem';
import { UIActions } from 'State/UI/UIActions';
import GameObject, { GameObjectEvent } from 'GameObject/GameObject';
import { applyDefaultButtonAnimation } from '../../UIHelper';
import { PopupID } from 'State/UI/PopupID';
import RelativePositionComponent from 'Component/Render/RelativePosition';
import Point from 'Utility/Point';
import { GameActions } from 'State/Game/GameActions';
import Game from 'Game';
import Sprite from 'Prototype/Sprite';
import TransformComponent from 'Component/Transform';
import { farmTransitionSceneId } from 'State/Game/GameScene';
import {
    getFarmItemsByWorld,
    getFarmItemThumbnailAssetName,
    getFarmItemThumbnailPath,
    handleItemSize,
    sortFarmItemsBySlotType,
} from 'System/Farm/FarmHelpers';
import SpriteComponent from 'Component/Render/Sprite';

type UnlockItemsPopupProps = {};

export class UnlockItemsPopup extends BaseMenu {
    private layout: any;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.FARM_UNLOCK_ITEMS, uiSystem, false);
    }

    public onShow(props: UnlockItemsPopupProps): void {
        this.layout = new UnlockItemsPopupLayout();
        this.layout.root.addComponent(RelativePositionComponent);
        this.layout.root.getComponent(RelativePositionComponent).relativePosition = new Point(0.5, 0.5);
        this.element.addChild(this.layout.root);

        this.handleItems();

        this.layout.continueButton.on(GameObjectEvent.SELECTED, this.handleContinueClick);
        this.layout.farmButton.on(GameObjectEvent.SELECTED, this.handleFarmClick);

        this.layout.character.addComponent(RelativePositionComponent).y = 0;

        [this.layout.continueButton, this.layout.farmButton].forEach(button => applyDefaultButtonAnimation(button));
    }

    private readonly handleItems = (): void => {
        const state = Game.store.getState();
        const itemsUnlocked = getFarmItemsByWorld(state.worldState.worldNumber).map(item => item.itemId);
        const panelOffset = 820 / itemsUnlocked.length;

        sortFarmItemsBySlotType(itemsUnlocked).forEach((itemId, index) => {
            const item = GameObject.Instantiate(Sprite, {
                name: itemId,
                texture: 'blank',
                anchor: new Point(0, 0.5),
                x: index * panelOffset,
                y: 35,
            });
            const spriteComponent = item.getComponent(SpriteComponent);
            const texture = getFarmItemThumbnailAssetName(itemId);
            // TODO: Use the thumbnails here as textures
            if (!Game.resource.existsOrQueued(texture)) {
                Game.resource.add(texture, getFarmItemThumbnailPath(itemId));
            }
            Game.resource.wait(texture).then(() => {
                spriteComponent.texture = texture;
            });
            handleItemSize(item.getComponent(TransformComponent), { width: 100, height: 200 });
            this.layout.itemsContainer.addChild(item);
        });
    };

    private readonly handleContinueClick = (): void => {
        UIActions.hidePopup(this.name);
    };

    private readonly handleFarmClick = (): void => {
        UIActions.hidePopup(this.name);
        GameActions.loadFarmScene({ loadingSceneId: farmTransitionSceneId });
    };
}
